import { gql } from 'urql';

const StartNewApplication = gql`
  mutation StartNewApplication(
    $idempotencyId: String!
    $products: [ApplicationProductTypeEnum!]!
  ) {
    startNewApplication(idempotencyId: $idempotencyId, products: $products) {
      __typename
      ... on StartNewApplicationSuccess {
        application {
          id
          ... on BankApplication {
            bankApplicationStatus
            productSelections
            firstName
          }
        }
      }
      ... on StartNewApplicationError {
        code
        title
        message
      }
    }
  }
`;

export default StartNewApplication;
